import { UseFormReturn } from 'react-hook-form'
import { CarBodyInspectionFormValues } from '~/entities/Inspection'
import { FormHeader } from '~/entities/Inspection/ui/FormHeader'
import {
  diskTypeEnumOptions,
  rubberTypeEnumOptions,
  wheelCodeEnumOptions,
} from '~/shared/config/constants'
import { WheelCodeEnum } from '~/shared/config/enums'
import { Checkbox, DrawerSelect } from '~/shared/ui/form'
import { WheelWrapper, Wrapper } from './styled'

type WheelsProps = {
  form: UseFormReturn<CarBodyInspectionFormValues>
}

const generateRubberTypeField = (key: WheelCodeEnum): never =>
  `wheels.${key}.rubberType` as never
const generateDiskTypeField = (key: WheelCodeEnum): never =>
  `wheels.${key}.diskType` as never

export function Wheels({ form }: WheelsProps) {
  const { watch, setValue, clearErrors } = form

  const isDiscrepanciesRubber = watch('isDiscrepanciesRubber')
  const isDiscrepanciesDisk = watch('isDiscrepanciesDisk')
  const canOneWheelChange = isDiscrepanciesRubber || isDiscrepanciesDisk

  watch((data, { name, type }) => {
    if (type !== 'change') return

    if (name === 'rubberType') {
      wheelCodeEnumOptions.forEach((wheel) => {
        setValue(generateRubberTypeField(wheel.id), data.rubberType as never)
      })
    }
    if (name === 'diskType') {
      wheelCodeEnumOptions.forEach((wheel) => {
        setValue(generateDiskTypeField(wheel.id), data.diskType as never)
      })
    }
    if (name === 'isDiscrepanciesRubber') {
      clearErrors('rubberType')

      if (isDiscrepanciesRubber) return
      wheelCodeEnumOptions.forEach((wheel) => {
        setValue(generateRubberTypeField(wheel.id), data.rubberType as never)
      })
    }
    if (name === 'isDiscrepanciesDisk') {
      clearErrors('diskType')

      if (isDiscrepanciesDisk) return
      wheelCodeEnumOptions.forEach((wheel) => {
        setValue(generateDiskTypeField(wheel.id), data.diskType as never)
      })
    }
  })

  return (
    <Wrapper>
      <DrawerSelect
        label='form.tire type'
        name='rubberType'
        title='form.tire type'
        defaultOptions={rubberTypeEnumOptions}
        validation={{
          required: !isDiscrepanciesRubber && 'validate.required field',
        }}
      />
      <DrawerSelect
        label='form.rim type'
        name='diskType'
        title='form.rim type'
        defaultOptions={diskTypeEnumOptions}
        validation={{
          required: !isDiscrepanciesDisk && 'validate.required field',
        }}
      />
      <Checkbox
        labelI18n='form.tire mismatch detected'
        name='isDiscrepanciesRubber'
      />
      <Checkbox
        labelI18n='form.rim mismatch detected'
        name='isDiscrepanciesDisk'
      />

      {canOneWheelChange &&
        wheelCodeEnumOptions.map((wheel) => (
          <WheelWrapper key={wheel.id}>
            <FormHeader title={wheel.label} />
            {isDiscrepanciesRubber && (
              <DrawerSelect
                label='form.tire type'
                name={`wheels.${wheel.id}.rubberType`}
                title='form.tire type'
                defaultOptions={rubberTypeEnumOptions}
                validation={{ required: 'validate.required field' }}
              />
            )}
            {isDiscrepanciesDisk && (
              <DrawerSelect
                label='form.rim type'
                name={`wheels.${wheel.id}.diskType`}
                title='form.rim type'
                defaultOptions={diskTypeEnumOptions}
                validation={{ required: 'validate.required field' }}
              />
            )}
          </WheelWrapper>
        ))}
    </Wrapper>
  )
}
